import React, { useCallback, useMemo } from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { activateUserDetailed } from 'actions/app-props';

import { startConversation } from 'services/chat-service';

import { getRoleLabel } from 'utils/user';

import CanUser from 'components/can-user';
import AvatarBase from 'components/avatar-base';
import DateTime from 'components/DateTime';
import UserChatButton from 'components/UserChatButton';
import UserLabels from 'components/UserLabels';

const UserCard = ({ image, color, secondaryColor, secondary_color, initials, name, online, onSubtitleClick, subtitleIcon, additional, email, subtitle, timezone, removed, role, id, pending, chatDisabled, onUserProfileClick, t }) => {

    const handleSubtitleClick = useCallback(() => {
        onSubtitleClick(id);
    }, [id, onSubtitleClick]);

    const handleUserProfileClick = useCallback(() => {
        activateUserDetailed(id);

        onUserProfileClick && onUserProfileClick();
    }, [id, onUserProfileClick]);

    const handleStartConversationClick = useCallback(() => {
        startConversation(id);
    }, [id]);

    const roleElement = useMemo(() => (
        <React.Fragment>
            { t(`roles.${getRoleLabel(role)}`) }

            { pending ? ` (${t('common:pending')})` : '' }
        </React.Fragment>
    ), [role, pending]);

    return (
        <div className="popout-inner">
            <div className="user-card">
                <div className="card-body">
                    <div className="card-body-side">
                        <AvatarBase
                            image={image}
                            color={color}
                            secondaryColor={secondaryColor || secondary_color}
                            text={initials}
                            size={'xlarge'}
                        />
                    </div>

                    <div className="card-body-main">
                        <h5><span>{name}</span> <i className={'status-indicator' + (online ? ' active' : '')} /></h5>

                        {
                            role && !subtitle ? (
                                <h6>{ roleElement }</h6>
                            ) : null
                        }

                        {
                            subtitle ? <h6 className={'subtitle' + (onSubtitleClick ? ' action' : '')} onClick={onSubtitleClick && handleSubtitleClick}>{subtitle} {subtitleIcon}</h6> : null
                        }

                        {
                            additional ? <h6 className="additional">{additional}</h6> : null
                        }

                        {
                            !subtitle && !additional ? (
                                <div className="labels-holder">
                                    <UserLabels id={id} />
                                </div>
                            ) : null
                        }
                    </div>
                </div>

                <div className="card-foot">
                    <CanUser type="viewMemberEmail">
                        {
                            role !== 'client' ? (
                                <div className="card-meta">
                                    <i className="icon material-icons">email</i>

                                    { email }
                                </div>
                            ) : null
                        }
                    </CanUser>

                    {
                        role && subtitle ? (
                            <div className="card-meta">
                                <i className="icon material-icons">person</i>

                                { roleElement }
                            </div>
                        ) : null
                    }

                    {
                        timezone ? (
                            <div className="card-meta">
                                <i className="icon material-icons">access_time</i>

                                <span>{<DateTime format="time">{moment().utcOffset((timezone || 0) * -1)}</DateTime>} ({t('date:local time')})</span>
                            </div>
                        ) : null
                    }

                    {
                        !removed ? (
                            <div className="card-cta">
                                <button className="btn btn-block btn-xsmall btn-secondary" onClick={handleUserProfileClick}>
                                    <i className="icon material-icons">person</i>

                                    { t('See profile') }
                                </button>

                                <UserChatButton id={id} role={role} pending={pending}>
                                    <button className="btn btn-block btn-xsmall btn-secondary" onClick={handleStartConversationClick}>
                                        <i className="icon ion ion-chatboxes" />

                                        { t('chat:Send message') }
                                    </button>
                                </UserChatButton>
                            </div>
                        ) : null
                    }
                </div>
            </div>
        </div>
    )

}

export default withTranslation(['user', 'common', 'date', 'Send message'])(UserCard);
